// Handles showing and hiding of dependant questions on the custom questions forms.

(function() {
  var snReviewModule = function () {
    var self = this;

    return {
      init: function() {
        self = this;
        self.minReviewLength = 140;
        self.reviewLengthMsg = "Please make sure you write at least 140 characters.";
        self.descriptionCount = 0;
              
        self.titleCount = 0;

        self._initReviewLength();
        self._initTitleLength();
        self._initFbAutoShare();
        self._initTwitterAutoShare();
      },

      _initReviewLength: function() {
        $('#Description').on('input', function() {
            self.descriptionCount = self._getReviewLength(self._readReview());            
            self._renderDescriptionCount();            
        });
      },

      _initTitleLength: function () {
        $('#Title').on('input', function () {
          self.titleCount = self._getTitleLength(self._readTitle());
          self._renderTitleCount();
        });
      },

      _initFbAutoShare: function() {
        $('#AutoShareFacebook').change(function() {
          var $input = $(this);
          if ($input.is(":checked")) {
            FB.login(function(response) {
              if (response.authResponse) {
                if (response.authResponse.grantedScopes.indexOf("publish_actions") === -1) {
                  $input.prop('checked', false);
                  $postButton.prop('value', "Post My Review");
                } else {
                  $("#AutoShareFacebookId").val(response.authResponse.userID);
                  $postButton.prop('value', "Post and Share my Review");
                }
              }
            }, {
              scope:"public_profile,publish_actions,email,user_friends,user_birthday,user_website,user_work_history,user_relationships,user_hometown,user_education_history",
              return_scopes: true
            });
          } else {
            $postButton.prop('value', "Post My Review");
          }
        });
      },

      _initTwitterAutoShare: function() {
        $('#AutoShareTwitter').change(function() {
          var $input = $(this);
          var $postButton = $("#submitReview");
          if ($input.is(":checked")) {
            $postButton.prop('value', "Post and Share my Review");
          } else {
            $postButton.prop('value', "Post My Review");
          }
        });
      },

      _readReview: function() {
        var review = $('#Description').val();
        return review;
      },

      _getReviewLength: function(review) {
        return review.replace(/\s+/g, " ").trim().length;
      },

      _renderDescriptionCount: function() {
        $('.write-review__characters small').text('Characters: ' + self.descriptionCount);
      },

      _readTitle: function () {
        var title = $('#Title').val();
        return title;
      },

      _getTitleLength: function (title) {
        return title.replace(/\s+/g, " ").trim().length;
      },

      _renderTitleCount: function () {
        $('.write-title__characters small').text('Characters: ' + self.titleCount);
      }
    };
  }();

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = snReviewModule;
  } else {
    window.snReviewModule = snReviewModule;
  }
})();
